import { render } from "./appointGift.vue?vue&type=template&id=4cf5915c&scoped=true"
import script from "./appointGift.vue?vue&type=script&lang=js"
export * from "./appointGift.vue?vue&type=script&lang=js"

import "./appointGift.vue?vue&type=style&index=0&id=4cf5915c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf5915c"]])

export default __exports__